import { api } from './../../../system/api';

export default {
    exportDeliveryNote: deliveryNoteId => api.put(`delivery-notes/${deliveryNoteId}/export`, {}, {
        singleRequest: true
    }),
};
